import { NgModule } from "@angular/core";
import { AutoStakingConfirmationComponent } from "@modules/staking/components/auto-staking-confirmation/auto-staking-confirmation.component";
import { RouterModule, Routes } from "@angular/router";
import { ModalHolderComponent } from "@modules/+new/shared/universal-modal/components/holder/modal-holder.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { AutoStakingCancelComponent } from "@modules/staking/components/auto-staking-cancel/auto-staking-cancel.component";

export enum AutoStakingRoutes {
	basePath = "auto-staking",
	confirmation = "auto-staking-confirmation",
	cancel = "auto-staking-cancel"
}

const routes: Routes = [
	{
		path: AutoStakingRoutes.confirmation,
		component: ModalHolderComponent,
		canActivate: [],
		data: {
			component: AutoStakingConfirmationComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: false,
				size: ModalSizes.md,
				extraClass: ["no-gutter"],
				preserveQueryParamsOnClose: false,
				allowBackdropCancel: true
			}
		}
	},
	{
		path: AutoStakingRoutes.cancel,
		component: ModalHolderComponent,
		canActivate: [],
		data: {
			component: AutoStakingCancelComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: false,
				size: ModalSizes.md,
				extraClass: ["no-gutter"],
				preserveQueryParamsOnClose: false,
				allowBackdropCancel: true
			}
		}
	}
];

@NgModule({
	declarations: [],
	imports: [AutoStakingConfirmationComponent, AutoStakingCancelComponent, RouterModule.forChild(routes)],
	exports: []
})
export class AutoStakingConfirmationModule {}
